/**
 * @module business 
 *  Apis must need auth details to trigger url - AuthApi
 */

import Env from '@/env';
const apiVersion = 'api/v1';
import store from '@/store/index';
import AuthApis from '@/controllers/AuthApis';
import ApiHelper from '@/controllers/ApiHelpers';

export default {
  /**
   * Fetch susers
   */
  getUsers({
    data,
    limit,
    page,
    sort='',
    order=''
  }) {
    let url = `${Env.loyaltyUrl}/${apiVersion}/users/search?limit=${limit}&page=${page}`;
    if(sort){
      url+=`&sort=${sort}&order=${order?order:'asc'}`
    }
    return AuthApis.postApi(url, null, data)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },

  /**
   * Create susers
   */
  createUser(data) {
    const url = `${Env.loyaltyUrl}/${apiVersion}/users/`;
    return AuthApis.postApi(url, null, data)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },


  /**
   * get by user ID
   */
  getUserById(user_id) {
    const url = `${Env.loyaltyUrl}/${apiVersion}/users/${user_id}`;
    return AuthApis.getApi(url, null)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },


  /**
   * update
   */
  update(user_id, data) {
    const url = `${Env.loyaltyUrl}/${apiVersion}/users/${user_id}`;
    return AuthApis.patchApi(url, null, data)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },

  /**
   * remove
   */
  remove(user_id) {
    const url = `${Env.loyaltyUrl}/${apiVersion}/users/${user_id}`;
    return AuthApis.deleteApi(url, null)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },

  /**
   * customer tax exempt
   */
  getCustomerTaxExempt(user_id) {
    const url = `${Env.productUrl}/api/location/customer/get/tax-exemption/${user_id}`;
    return AuthApis.getApi(url, {
      'Authorization': 'Bearer ' + store.getters['auth/userToken'],
        api_token: Env.productApiToken,
    })
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },

  /**
   * customer tax exempt
   */
  updateCustomerTaxExempt(user_id, data) {
    const url = `${Env.productUrl}/api/location/customer/sync/tax-exemption/${user_id}`;
    return AuthApis.putApi(url, {
      'Authorization': 'Bearer ' + store.getters['auth/userToken'],
        api_token: Env.productApiToken,
    }, data)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  }


}